module.exports = __webpack_public_path__ + "static/media/car_white.1599a5e7.jpg";